import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { debounceTime, finalize, switchMap } from 'rxjs/operators';
import { BrandsServiceProxy, CreateOrEditBrandDto, CreateOrEditStockAdjustmentTypeDto, StockAdjustmentTypeServiceProxy } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

@Component({
    selector: 'createOrEditStockAdjustmentTypeModal',
    templateUrl: './create-or-edit-stockAdjustmentType.component.html',
    standalone: false,
})
export class CreateOrEditStockAdjustmentTypeModalComponent extends AppComponentBase implements OnInit {
    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;

    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    stockAdjustment: CreateOrEditStockAdjustmentTypeDto = new CreateOrEditStockAdjustmentTypeDto();

    constructor(
        injector: Injector,
        private _stockAdjustmentTypeServiceProxy: StockAdjustmentTypeServiceProxy,
        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    ngOnInit(): void {}

    show(typeId?: number): void {
        if (!typeId) {
            this.stockAdjustment = new CreateOrEditStockAdjustmentTypeDto();
            this.stockAdjustment.id = typeId;

            this.active = true;
            this.modal.show();
        } else {
            this._stockAdjustmentTypeServiceProxy.getStockAdjustmentTypForEdit(typeId).subscribe((result) => {
                this.stockAdjustment = result.stockAdjustmentType;

                this.active = true;
                this.modal.show();
            });
        }
    }

    save(): void {
        this.saving = true;

        this._stockAdjustmentTypeServiceProxy
            .createOrEdit(this.stockAdjustment)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.close();
                this.modalSave.emit(null);
            });
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }
}
